import {Devices} from '../records/systemStateRecord';

function getReviewPageSize(deviceType) {
    const DESKTOP_COUNT = 5;
    const MOBILE_COUNT = 10;

    return deviceType === Devices.mobile ? MOBILE_COUNT : DESKTOP_COUNT;
}

export {getReviewPageSize};
